export default "__VITE_ASSET__6be34a57__"